module.exports = {
    API_URL: "https://asia-east2-toyota-khon-kaen.cloudfunctions.net/api",
    // API_URL: "http://localhost:5001/toyota-khon-kaen/asia-east2/api",
    roleStr: [
        "สมัครสมาชิกใหม่",
        "พนักงาน",
        "แอดมิน",
    ],
}